module.exports = __webpack_public_path__ + "img/PB_Logo_20Jahre.5519142.svg";